<template>
	<section id="create-account-form" class="container">
		<div class="row">
			<div class="col-md-10">
				<h2>New account</h2>
				<form class="my-3">
					<div class="form-row">
						<TextInput
							inputId="firstName"
							v-model="firstName"
							labelText="First name"
							:wrapperClasses="['col-md-6']"
						/>
					</div>
					<div class="form-row">
						<TextInput
							inputId="lastName"
							v-model="lastName"
							labelText="Last name"
							:wrapperClasses="['col-md-6']"
						/>
					</div>
					<div class="form-row">
						<TextInput
							inputId="email"
							v-model.trim="email"
							labelText="Email address"
							:wrapperClasses="['col-md-6']"
							:validation="[{type:'email',msg:'Please provide a valid email'}]"
							:validateEmail="!loading"
						/>
					</div>
					<div class="form-row">
						<TextInput
							inputId="password"
							v-model="password"
							labelText="Password"
							autocomplete="new-password"
							:password="true"
							:helpText="'At least 8 characters in length and must contain at least one of each of these characters: uppercase, lowercase, symbol, number'"
							:wrapperClasses="['col-md-6']"
						/>
					</div>
					<div class="form-row">
						<TextInput
							inputId="passwordConfirm"
							v-model="passwordConfirm"
							labelText="Confirm password"
							:password="true"
							autocomplete="new-password"
							:validation="[{type:'match',value:password,msg:'Passwords don\'t match'}]"
							:wrapperClasses="['col-md-6']"
						/>
					</div>
					<div class="form-row">
						<TextInput
							inputId="address1"
							v-model="address1"
							labelText="Address"
							placeholder="Address Line 1"
							:wrapperClasses="['col-md-6']"
						/>
					</div>
					<div class="form-row">
						<TextInput
							inputId="address2"
							v-model="address2"
							labelText="Address"
							placeholder="Address Line 2"
							:isRequired="false"
							:srOnly="true"
							:wrapperClasses="['col-md-6']"
						/>
					</div>
					<div class="form-row">
						<TextInput inputId="city" labelText="City" v-model="city" />
						<SelectInput inputId="province" labelText="Province" v-model="province" :options="provinces" />
					</div>
					<div class="form-row">
						<TextInput
							inputId="postalCode"
							labelText="Postal code"
							v-model="postalCode"
							helpText="Example A1B 2C3"
							:validation="[{type:'max',value:15,msg:'This field can\'t be more than 15 characters'}]"
						/>
					</div>
					<div class="form-row">
						<TextInput
							inputId="phone"
							labelText="Phone"
							helpText="Example: 905-615-3200"
							v-model="phone"
							:validation="[{type:'phone',value:null,msg:'Please input a valid phone number'}]"
						/>
					</div>
					<div class="form-row">
						<div class="col-auto">
							<h4>Terms and conditions</h4>
							<p>Personal information on this form is collected under the authority of Section 11 of the Municipal Act, 2001 and the City of Mississauga Policy No. 06-03-02. The information will be used to process applications and in public notices to the community. Questions about this collection should be directed to the City of Mississauga, Supervisor, Film &amp; Television, 300 City Centre Drive, Mississauga ON L5B 3C1 Tel: 905-615-3200, ext. 6150. E-mail: film.office@mississauga.ca</p>
						</div>
					</div>
					<div class="form-row my-3">
						<CheckboxInput
							inputId="agree"
							v-model="agree"
							labelText="I have read and agree to the terms and conditions."
						/>
					</div>
					<!-- <div class="form-row">
                        <div class="d-flex justify-content-end mb-3">
                            <vue-recaptcha
                                sitekey="6LePGyYTAAAAAHF6DUmTXY-DhX4d931Njqs1_zEY"
                                @verify="recaptchaVerify"
                                @expire="recaptchaIsValid = false; recaptchaToken = '';"
                            ></vue-recaptcha>
                        </div>
                        <div
                            class="my-3 alert alert-danger"
                            v-if="submitted && !recaptchaIsValid"
                        >Please confirm the recaptcha box.</div>
					</div>-->
					<div class="form-row">
						<button
							:class="['btn' ,'btn-primary',disableCreateButton ? 'disabled':'']"
							type="submit"
							@click.prevent="createAccount"
							:disabled="disableCreateButton"
						>Create account</button>
						<div class="spinner-container" v-if="loading">
							<div class="spinner"></div>
						</div>
					</div>
				</form>
			</div>
		</div>
	</section>
</template>

<script>
import { PROVINCES } from "@/constants/constants.js";
import TextInput from "@/components/inputs/TextInput";
import CheckboxInput from "@/components/inputs/CheckboxInput.vue";
import SelectInput from "@/components/inputs/SelectInput.vue";
// import VueRecaptcha from "vue-recaptcha";

export default {
	name: "CreateAccountForm",
	components: {
		TextInput,
		CheckboxInput,
		SelectInput
		// VueRecaptcha
	},
	data() {
		return {
			email: "",
			password: "",
			passwordConfirm: "",
			passwordResetQuestion: "not used",
			passwordResetAnswer: "not used",
			firstName: "",
			lastName: "",
			company: "not used",
			position: "not used",
			address1: "",
			address2: "",
			city: "",
			province: "",
			postalCode: "",
			country: "",
			phone: "",
			phone2: "not used",
			agree: false,
			submitted: false,
			emailStatus: "initial",
			provinces: PROVINCES,
			disableCreateButton: false
			// recaptchaAlert: false,
			// recaptchaIsValid: false,
			// recaptchaToken: ""
		};
	},
	computed: {
		loading() {
			return this.$store.getters.isLoading;
		},
		user() {
			const userData = JSON.stringify({
				Email: this.email.toLowerCase(),
				Password: this.password,
				PasswordConfirm: this.passwordConfirm,
				PasswordResetQuestionId: "not used",
				PasswordResetAnswer: "not used",
				FirstName: this.firstName,
				LastName: this.lastName,
				Company: "not used",
				Position: "not used",
				AddressLine1: this.address1,
				AddressLine2: this.address2,
				Address: this.address1 + this.address2,
				City: this.city,
				Province: this.province,
				PostalCode: this.postalCode,
				Country: "Canada",
				Phone: this.phone,
				Phone2: "not used",
				Agreement: this.agreement
				// Recaptcha_Token: this.recaptchaToken
			});
			return userData;
		}
	},
	methods: {
		createAccount() {
			this.submitted = true;

			if (!this._errorsExist() && !this.disableCreateButton) {
				this.disableCreateButton = true;

				this.$store
					.dispatch("AUTH_NEW_USER", this.user)
					.then(resp =>
						resp == "success"
							? this.$emit("success")
							: this.$emit("failed")
					)
					.then(this.$router.push("/create-account"))
					.catch(err => err);
			}
		}
		// recaptchaVerify(evt) {
		//     this.recaptchaToken = evt;
		//     this.recaptchaIsValid = true;
		// }
	}
};
</script>
